import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9843c72a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex col-12 mxa-main h-100" }
const _hoisted_2 = {
  key: 0,
  class: "collapse d-md-block mxa-main-login-menu"
}
const _hoisted_3 = {
  class: "flex-grow-1",
  "data-test": "main_router"
}
const _hoisted_4 = { class: "d-flex justify-content-center h-100" }

import { useStore } from '@/store'
import SideMenu from './menu/SideMenu.vue'


import { defineComponent, computed } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MainAll',
  setup(__props) {

const store = useStore()
// ログイン状態
// ログイン中は左にメニューを表示する
const isLogin = computed(() => store.getters.loginstatus)
// 他機能情報 現状はヘルプのみ
const isOther = computed(() => store.getters.isOtherStatus)

// url毎のメイン領域のclass名
const contentClass = computed(() => {
  // 他機能画面
  if (isOther.value) {
    return 'col-12'
  }
  // ログイン後画面
  if (isLogin.value) {
    return 'col-11 mxa-main-login'
  }
  // ログイン前画面
  return 'col-11 col-sm-11 mxa-main-nologin'
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mxa-area", { 'mxa-area-login': _unref(isLogin) }]),
    "data-test": "area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isLogin))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(SideMenu, { "data-test": "sideMenu" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["h-100", _unref(contentClass)]),
            "data-test": "main_content"
          }, [
            _createVNode(_component_router_view)
          ], 2)
        ])
      ])
    ])
  ], 2))
}
}

})